<template>
    <div class="mb-20 mb-md-30">
        <v-row align="center" justify="space-between" class="row--x-small">
            <v-col cols="12" md="auto">
                <div class="mb-4 mb-md-0" v-if="!onlySearch">
                    <span class="font-size-16 grey-68--text">
                        검색결과 <span class="font-weight-bold primary--text">{{ totalCount }}</span
                        >건
                    </span>
                </div>
            </v-col>
            <v-col cols="12" md="auto">
                <v-text-field v-model="searchValue" @keydown.enter="search" outlined hide-details append-icon="mdi-magnify" @click:append="search">
                    <template #prepend>
                        <v-select v-model="searchKey" :items="searchKeys" outlined hide-details />
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="auto">
                <v-select :value="sort" :items="sortMethods" @input="(sort) => $router.push({ query: { ...this.$route.query, sort, page: 1 } })" outlined hide-details class="w-100 mw-md-200px" v-if="!onlySearch" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
const searchKeys = [
    { text: "전체", value: null },
    { text: "LOT", value: "lot" },
    { text: "작품명", value: "subject" },
    { text: "작가명", value: "author" },
];
const sortMethods = [
    { text: "LOT번호", value: "lot_desc" },
    { text: "높은추정가", value: "price_estimated_desc" },
    { text: "낮은추정가", value: "price_estimated_asc" },
    { text: "높은시작가", value: "price_auction_from_desc" },
    { text: "낮은시작가", value: "price_auction_from_asc" },
    { text: "높은현재가", value: "price_auction_current_desc" },
    { text: "낮은현재가", value: "price_auction_current_asc" },
    { text: "많은응찰", value: "bids_length_desc" },
    { text: "적은응찰", value: "bids_length_asc" },
];
export default {
    props: {
        totalCount: { type: Number, default: 0 },
        onlySearch: { type: Boolean, default: false },
    },
    data() {
        return {
            sortMethods,
            searchKeys,
            searchKey: this.$route.query.searchKey || null,
            searchValue: this.$route.query.searchValue || null,
        };
    },
    computed: {
        sort() {
            return this.$route.query.sort || "lot_desc";
        },
    },
    watch: {
        "$route.query.searchKey"() {
            this.searchKey = this.$route.query.searchKey || null;
            this.searchValue = this.$route.query.searchValue || null;
        },
        "$route.query.searchValue"() {
            this.searchKey = this.$route.query.searchKey || null;
            this.searchValue = this.$route.query.searchValue || null;
        },
    },
    methods: {
        search() {
            const { searchKey, searchValue } = this;
            this.$router.push({ query: { ...this.$route.query, page: 1, searchKey, searchValue } });
        },
    },
};
</script>
